<script setup lang="ts">
import { computed, useAttrs } from "vue";

const props = defineProps<{
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
}>();

defineOptions({ inheritAttrs: false });
const attrs = useAttrs();

// 内部画像 (相対 or / 始まり) で .png / .jpg / .jpeg のときのみ
// 同パスの .webp を type="image/webp" として優先 srcset に追加。
// 外部 URL (http(s)://) は自前で webp を持っていないので素通し。
const isInternal = computed(() => /^\/[^/]/.test(props.src));
const webpSrc = computed(() =>
  isInternal.value
    ? props.src.replace(/\.(png|jpe?g)(\?|$)/i, ".webp$2")
    : props.src,
);
const hasWebp = computed(() => webpSrc.value !== props.src);
</script>

<template>
  <picture v-if="hasWebp">
    <source :srcset="webpSrc" type="image/webp" />
    <img
      :src="src"
      :alt="alt"
      :width="width"
      :height="height"
      v-bind="attrs"
    />
  </picture>
  <img
    v-else
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    v-bind="attrs"
  />
</template>
